import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelope,
  faPhone,
  faGlobe,
  faEarthAmerica,
} from "@fortawesome/free-solid-svg-icons";
import { console_log, showToast } from "../../utils/commonHelper";

const ResumeViewer = ({ resume }) => {
  // const resumeReduxData = useSelector(
  //   (state) => state.resumeDetails.resume_json
  // );
  const [resumeData, setResumeData] = useState();
  useEffect(() => {
    // console_log("resumeReduxData.....", resumeReduxData);
    if (resume) {
      setResumeData(resume);
    }
  }, [resume]);

  return (
    <div className="resume-container">
      <div className="header">
        <h1 className="name">{resumeData?.name}</h1>
        <div className="contact">
          {resumeData?.contact.location && (
            <div className="contact-item">
              <FontAwesomeIcon icon={faLocationDot} className="icon-color" />
              <span>{resumeData?.contact.location}</span>
            </div>
          )}
          {resumeData?.contact.email && (
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="icon-color" />
              <span>{resumeData?.contact.email}</span>
            </div>
          )}
          {resumeData?.contact.phone && (
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} className="icon-color" />
              <span>{resumeData?.contact.phone}</span>
            </div>
          )}
          {resumeData?.contact.website && (
            <div className="contact-item">
              <FontAwesomeIcon icon={faEarthAmerica} className="icon-color" />
              {/* <span>{resumeData?.contact.website}</span> */}
              <a
                href={
                  resumeData.contact.website.startsWith("http")
                    ? resumeData.contact.website
                    : `https://${resumeData.contact.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="website-link"
              >
                {resumeData.contact.website}
              </a>
            </div>
          )}
        </div>
      </div>

      <div className="section">
        <h2 className="section-title">Summary</h2>
        <div className="summary">
          <ul>
            {resumeData?.summary.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title">Key Skills</h2>
        <div className="skills-list">
          {resumeData?.key_skills.map((skill, index) => (
            <span key={index} className="skill-tag">
              {skill}
            </span>
          ))}
        </div>
      </div>

      <div className="section">
        <h2 className="section-title">Professional Experience</h2>
        <div>
          {resumeData?.professional_experience.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="job-header">
                <div>
                  <div className="job-title">{exp.title}</div>
                  <div className="company">{exp.company}</div>
                </div>
                <span className="date">{exp.date}</span>
              </div>
              <ul className="job-description">
                {exp.description.map((desc, idx) => (
                  <li key={idx}>{desc}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="section">
        <h2 className="section-title">Education</h2>
        <div>
          {resumeData?.education.map((edu, index) => (
            <div key={index} className="education-item">
              <div className="job-header">
                <div>
                  <div className="job-title">{edu.degree}</div>
                  <div className="company">{edu.university}</div>
                </div>
                <span className="date">{edu.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResumeViewer;
